const getInitials = (name) => {
    const words = name.split(' ');
    const initials = words.map(word => word[0].toUpperCase()).join('');
    return initials;
};

const UserIcon = ({ onClick }) => {
    const userName = sessionStorage.getItem('name') || '';
    const hasProfilePicture = false;

    return (
        <div className="bg-custom_red w-12 h-12 rounded-full cursor-pointer flex items-center justify-center" onClick={onClick}>
            {hasProfilePicture ? (
                <svg class="absolute w-12 h-12 text-gray-400 -left-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"></path></svg>
            ) : (
                <div className="relative text-white text-xl font-poppins font-bold">
                    {getInitials(userName)}
                </div>
            )}
        </div>
    );
};

export default UserIcon;
